<div
  *ngIf='studentIncorrectExercisesGroup[0].exercise_type === TaskTypes.EXERCISE_CALCULATION'>
  <div class='inline-exercise'
       *ngFor='let incorrectExercise of studentIncorrectExercisesGroup'>
    <ng-katex-paragraph  class='exercise-task' [paragraph]="incorrectExercise.exercise_text|exerciseFormat:'text'"></ng-katex-paragraph >

    <span class='wrong-answer'>{{incorrectExercise.shortAnswer}}</span>
    <span
      class='correct-answer'>| {{getCorrectAnswers(incorrectExercise)}}</span><span>;</span>
  </div>
</div>
<div
  *ngIf='studentIncorrectExercisesGroup[0].exercise_type === TaskTypes.EXERCISE_TASK'>
  <div *ngFor='let incorrectExercise of studentIncorrectExercisesGroup'
       class='exercise-type-task'>
      <ng-katex-paragraph  class='exercise-task'
                          [paragraph]="incorrectExercise.exercise_text |exerciseFormat:'text'"></ng-katex-paragraph >
    <span class='exercise-answer-text'>Ответ: </span>
    <span class='wrong-answer'>{{incorrectExercise.shortAnswer}}</span>
    <span
      class='correct-answer'>| {{getCorrectAnswers(incorrectExercise)}}</span>
  </div>
</div>
<div
  *ngIf='studentIncorrectExercisesGroup[0].exercise_type === TaskTypes.EXERCISE_LOGIC'>
  <div *ngFor='let incorrectExercise of studentIncorrectExercisesGroup'
       class='exercise-type-logic'>
      <ng-katex-paragraph  class='exercise-task'
                          [paragraph]="incorrectExercise.exercise_text |exerciseFormat:'text'"></ng-katex-paragraph >
    <span class='exercise-answer-text'>Ответ: </span>
    <span class='wrong-answer'>{{incorrectExercise.shortAnswer}}</span>
    <span
      class='correct-answer'>| {{getCorrectAnswers(incorrectExercise)}}</span>
  </div>
</div>
<div
  *ngIf='studentIncorrectExercisesGroup[0].exercise_type === TaskTypes.EXERCISE_SEQUENCE'>
  <div class='inline-exercise'
       *ngFor='let incorrectExercise of studentIncorrectExercisesGroup'>
      <ng-katex-paragraph  class='exercise-task'
                          [paragraph]="incorrectExercise.exercise_text |exerciseFormat"></ng-katex-paragraph >
    <span
      class='wrong-answer answer--underlined'>{{incorrectExercise.shortAnswer}}</span>

      <ng-katex-paragraph  class='correct-answer'
                          [paragraph]="'|' + (incorrectExercise.exercise_text | exerciseFormat)"></ng-katex-paragraph >
    <span
      class='correct-answer answer--underlined'> {{getCorrectAnswers(incorrectExercise)}}</span>
    <span>;</span>
  </div>
</div>
<div
  *ngIf='studentIncorrectExercisesGroup[0].exercise_type === TaskTypes.EXERCISE_MAGIC_BOX'>
  <div *ngFor='let incorrectExercise of studentIncorrectExercisesGroup'
       class='inline-exercise'>
    <table class="magic-box">
      <tr
        *ngFor="let row of incorrectExercise._exercise_text; let rowIdx=index">
        <td *ngFor="let elem of row; let colIdx=index"
            [ngClass]="getMagicBoxTdStyles(incorrectExercise, rowIdx, colIdx)">
          <div *ngIf="elem != null"
               class="magic-box-cell-task">{{ elem }}
          </div>
          <div
            *ngIf="elem == null && compareMagicBoxAnswers(incorrectExercise, rowIdx, colIdx)"
            class="magic-box-cell-right">{{ getMagicBoxCellRight(incorrectExercise, rowIdx, colIdx) }}
          </div>
          <div
            *ngIf="elem == null && !compareMagicBoxAnswers(incorrectExercise,rowIdx,colIdx)">
            <span
              class="magic-box-cell-task correct-answer">{{ getMagicBoxCellRight(incorrectExercise, rowIdx, colIdx) }}</span>
            <span
              class="magic-box-cell-task wrong-answer">{{ getMagicBoxCellWrong(incorrectExercise, rowIdx, colIdx) }}</span>
          </div>
        </td>
      </tr>
    </table>
  </div>
</div>
<div
  *ngIf='studentIncorrectExercisesGroup[0].exercise_type === TaskTypes.EXERCISE_PUZZLE_TASK || studentIncorrectExercisesGroup[0].exercise_type === TaskTypes.EXERCISE_PUZZLE_EXAMPLE'>
  <div *ngFor='let incorrectExercise of studentIncorrectExercisesGroup'
       class='exercise-type-puzzle'>
      <ng-katex-paragraph  class='exercise-task'
                          [paragraph]="incorrectExercise.exercise_text |exerciseFormat"></ng-katex-paragraph >
    <span class='exercise-answer-text'>Ответ: </span>
    <span class='wrong-answer'>{{incorrectExercise.shortAnswer}}</span>
    <span
      class='correct-answer'>| {{getCorrectAnswers(incorrectExercise)}}</span>
  </div>
</div>

